import { PensionOption } from "../../../../../../../../Wrap/Constants/Enums/Apply/PensionOption";
import { ProcessType } from "../../../../../../../../Wrap/Constants/Enums/Client/DashboardFilter/ProcessType";
import { DisinvestmentStrategy } from "../../../../../../../../Wrap/Constants/Enums/Domain/DisinvestmentStrategy";
import { Frequency } from "../../../../../../../../Wrap/Constants/Enums/Domain/Frequency";
import { CrystallisationOption } from "../../../../../../../../Wrap/Constants/Enums/Drawdown/CrystallisationOption";
import { DrawdownType } from "../../../../../../../../Wrap/Constants/Enums/Drawdown/DrawdownType";
import { PensionPathwayInvestmentOption } from "../../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/Shared/PensionPathwayInvestmentOption";

export const DrawdownTypeOptionsMap = {
    [DrawdownType.Flexible]: "Single Flexible Drawdown",
    [DrawdownType.Regular]: "Tailored Drawdown",
    [DrawdownType.Capped]: "Single Capped Drawdown",
    [DrawdownType.UFPLS]: "UFPLS",
};

export const PensionOptionMap = {
    [PensionOption.Drawdown]: "Drawdown",
    [PensionOption.UFPLS]: "Uncrystallised funds pension lump sum",
};

export enum ChooseAssetsToSellFor {
    Drawdown,
    Income,
}

export const crystallisationAmountErrorMessage = {
    valueToCrystalliseIsZero:
        "The value available to crystallise is zero so you cannot complete the drawdown at this time.",
    inputIsZeroAndLessThanUncrystallised:
        "Please enter a drawdown amount that is greater than zero and less than or equal to the value available to crystallise.",
    inputIsZeroAndEqualUncrystallised:
        "Please enter a drawdown amount that is greater than zero and less than the value available to crystallise.",
    inputEqualValueToCrystallise:
        'The amount you have entered is equal to the total value available to crystallise. If you want to crystallise the whole amount, please choose "Full" for your drawdown options.',
    inputGreaterThanValueToCrystalliseAndLessThanUncrystallised:
        "The amount you have entered is greater than the value available to crystallise. Please enter a drawdown amount that is greater than zero and less than or equal to the value available to crystallise.",
    inputGreaterThanValueToCrystalliseAndEqualUncrystallised:
        "The amount you have entered is greater than the value available to crystallise. Please enter a drawdown amount that is greater than zero and less than the value available to crystallise.",
    inputGreaterThanAvailableCash:
        "The amount you have entered is greater than the available cash. Please enter a drawdown amount that is greater than zero and less than available cash.",
};

export const drawdownDetailsMessage = {
    crystallisationOptionErrorMessage:
        "You will need to cancel the process because the client has entitlements that require this to be a full drawdown, but the value available to crystallise is less than the uncrystallised fund value.",
    crystallisationOptionFullErrorMessage: "Can not select full drawdown.",
    LTAInputErrorMessage:
        "Please enter a value for the LTA crystallised off platform that is equal to or greater than 0%",
    LTAMaxErrorMsg: "Please enter a value for the LTA crystallised off platform that is between 0% and 999.99%.",
    regularCrystallisationAmountErrorMessage: "Please enter an amount that is greater than zero",
};

export const CrystallisationOptions = [CrystallisationOption.Full, CrystallisationOption.Partial];
export const CrystallisationOptionsMap = {
    [CrystallisationOption.Full]: "Full",
    [CrystallisationOption.Partial]: "Partial",
};

export const LTADetailHeading = {
    previousLTA: "Lifetime allowance (LTA) previously used in this account",
    LTABefore2006: "LTA used by benefits that commenced before 6 April 2006",
    availableLTA: "Available LTA",
    otherLTA: "Other LTA used you need to tell us about",
    LTAByThisCrystallisation: "LTA % used by this drawdown",
    LTAInTotal: "LTA % used in total following this drawdown",
    crystallisationAmountSubjectToLTAExcessCharge: "Amount of drawdown subject to LTA excess charge",
    estimateLTAForInitialCrystallisation: "Estimated LTA % usage for initial drawdown",
    estimateLTAPerRegularCrystallisation: "Estimated LTA % usage per regular drawdown",
    estimateAvailableLTAInAYear: "Estimated available LTA after a year",
    estimateLTAUsedInAYear: "Estimated LTA that will be used after a year",
    estimateTotalLTAUsedInAYear: "Estimated total LTA that will be used after a year",
    estimatedChargeableCrystallisation: "Estimated chargeable portion of drawdown after a year",
    crystallisationChargeablePortion: "Chargeable portion of drawdown",
    isPartOfUsedSIHBefore75:
        "Was part of this LTA used in respect of a Serious Ill Health Lump Sum taken prior to age 75?",
};

export const LTADetailTooltiopMessage = {
    previousLTA: "TBC by Pension pod/SL props",
    otherLTA: "TBC by Pension pod/SL props",
    LTAByThisCrystallisation:
        "This is the percentage of the lifetime allowance for the current tax year that will be used by your client's drawdown.",
    LTAInTotal:
        "This is the total lifetime allowance for the current tax year that will be used once this drawdown is added to any previous drawdowns taken by your client.",
    estimatedChargeableCrystallisation:
        "This is the estimated amount that we will crystallise in order to achieve the required income",
};

export const AllowanceDetailHeading = {
    ltaDetails: "Allowance Details",
    lsaDetails: "Lump Sum Allowance (LSA) details",
    lsdbaDetails: "Lump Sum and Death Benefit Allowance (LSDBA) details",
    ltaPreviouslyCrystallisedOnPlatform: "Lifetime allowance (LTA) previously crystallised on platform",
    ltaUsedByBenefitsThatCommencedPriorToDate: "LTA used by benefits that commenced prior to 06/04/2006",
    ltaCrystallisedOffPlatform: "LTA crystallised off platform not including transfers already made to the platform",
    ltaUsed: "Lifetime allowance used",
    lsaUsedAsAt5April2024Amount: "LSA previously used in this account, as at 5 April 2024",
    lsaUsedOnOrAfter6April2024Amount: "LSA previously used in this account, on or after 6 April 2024",
    lsaUsedBefore6April2006Amount: "LSA used by benefits that commenced before 6 April 2006",
    lsaOtherUsedAsAt5April2024Amount: "Other LSA as at 5 April 2024 you need to tell us about",
    lsaOtherUsedOnOrAfter6April2024Amount: "Other LSA on or after 6 April 2024 you need to tell us about",
    lsdbaUsedLSDBAAsAt5April2024Amount: "LSDBA previously used in this account, as at 5 April 2024",
    lsdbaUsedLSDBAOnOrAfter6April2024Amount: "LSDBA previously used in this account, on or after 6 April 2024",
    lsdbaUsedLSDBABefore6April2006Amount: "LSDBA used by benefits that commenced before 6 April 2006",
    lsdbaOtherLSDBAUsedAsAt5April2024Amount: "Other LSDBA as at 5 April 2024 you need to tell us about",
    isPartOfUsedSIHBefore75:
        "Was part of this amount used in respect of a Serious Ill Health Lump Sum taken prior to age 75?",
    lsdbaOtherLSDBAUsedOnOrAfter6April2024Amount: "Other LSDBA on or after 6 April 2024 you need to tell us about",
    hasTakenIllHealthLumpSum: "Has a Serious Ill Health Lump Sum previously been taken?",
    lsaUsedBycrystallisation: "LSA used by this crystallisation",
    lsaUsedFollowingBycrystallisation: "LSA used following this crystallisation",
    lsdbaUsedBycrystallisation: "LSDBA used by this crystallisation",
    lsdbaUsedFollowingBycrystallisation: "LSDBA used following this crystallisation",
    lsaUsedByRegularCrystallisation: "LSA used by the regular crystallisation",
    lsdbaUsedByRegularCrystallisation: "LSDBA used by the regular crystallisation",
    lsaUsedByInitialCrystallisation: "LSA used by this initial crystallisation",
    lsdbaUsedByInitialCrystallisation: "LSDBA used by this initial crystallisation",
};

export const DisinvestmentStrategyMap = {
    [DisinvestmentStrategy.NotSpecified]: "Not Specified",
    [DisinvestmentStrategy.Proportional]: "Proportional",
    [DisinvestmentStrategy.Volatility]: "Volatility",
    [DisinvestmentStrategy.SpecifiedAssets]: "Specified Assets",
};

export const FrequencyMap = {
    [Frequency.NotSpecified]: "NotSpecified",
    [Frequency.Daily]: "Daily",
    [Frequency.Weekly]: "Weekly",
    [Frequency.Monthly]: "Monthly",
    [Frequency.Quarterly]: "Quarterly",
    [Frequency.HalfYearly]: "Half Yearly",
    [Frequency.Yearly]: "Yearly",
    [Frequency.Fortnightly]: "Fortnightly",
    [Frequency.Termly]: "Termly",
    [Frequency.SemiDaily]: "Semi-daily",
};

export const PensionPathwayInvestmentOptionArray = [
    PensionPathwayInvestmentOption.NotSpecified,
    PensionPathwayInvestmentOption.InvestmentPathway,
    PensionPathwayInvestmentOption.SelectInvestments,
    PensionPathwayInvestmentOption.CurrentInvestments,
];

export const PensionPathwayInvestmentOptionArrayMap = {
    [PensionPathwayInvestmentOption.NotSpecified]: "-- please select --",
    [PensionPathwayInvestmentOption.InvestmentPathway]: "Use investment pathways",
    [PensionPathwayInvestmentOption.SelectInvestments]: "Select investments without using investment pathways",
    [PensionPathwayInvestmentOption.CurrentInvestments]: "Continue with current investments",
};

export const DrawdownSwitchLabelMessage = {
    switchInvestments: "Switch investments",
    switchFrom: "Switch from investments",
    switchTo: "Switch to investments",
    switchInvestmentsQuestion: "Do you wish to switch investments?",
    totalSwitchFrom: "Total switch from",
    totalOrderValue: "Total order value",
};

export const DrawdownSwitchValidationMessage = {
    total100: "Please enter values against the assets to switch that total 100%.",
    allowDecimals: "only allow two decimal places",
    valueMustLargerThan0: "Value must larger than 0",
    valueMustNotLargerThan: "Value must not larger than ",
    restrict: "An account with suspended or restricted activities cannot setup sell investments",
    moreThan100PercentSwitchFrom:
        "Please enter a value to switch that is less than 100% and equates to less than 100% of the current estimated value of the fund, or select switch all.",
    moreThan100PercentSwitchTo:
        "Please enter a value to switch that is less than 100% and equates to less than 100% of the current estimated value of the fund.",
    exceed95ofTotal: "Product allocation value exceeds 95% of total holding value.",
    greaterThanEstimated:
        "You have entered a value to switch that is greater than the current estimated value of the asset.",
    equalEstimatedValue:
        "You have entered a value that is equal to the current estimated value of the asset. You may either choose to 'switch all' or reduce the value that you wish to switch.",
    noHoldings: "There are no holdings in this product available to sell",
    selectRequired: "Please select",
    enterRequired: "Please enter",
};

// SLP-57806.FR.08
export const InvestmentPathwayWarningMessages = {
    TPBNoOuterRing: "This investment pathway will override the existing pension holdings.  If regular contributions are also being made into the pension, these need to be redirected to the investment pathway.",
    TPBWithOuterRing: "As the current assets include outer-ring investments, please initiate the switch to the investment pathway outside of this transaction.  If regular contributions are also being made into the pension, these need to be redirected to the investment pathway. The illustration will assume the assets are switched into the investment pathway.",
    TopUpWithITFCNoOuterRing: "This investment pathway will override the previous investment choice(s) for the pension and amend the existing pension holdings.  If regular contributions are being made into the pension, these need to be redirected to the investment pathway.",
    TopUpWithITFCWithOuterRing : "As the current assets include outer-ring investments, please initiate the switch to the investment pathway outside of this transaction. If regular contributions are being made into the pension, these need to be redirected to the investment pathway. You may wish to change the investment choice(s) for the top up being made as part of this transaction.",
    WhatIf: "This investment pathway will override the existing pension holdings and investment selection for any contributions for the purpose of the illustration.",
    NewBusiness: "This investment pathway will override the previous investment choice(s) for the pension.",
};

export const DrawdownPriceLockMessage = {
    TooltipMessage: "Where disinvestment is required for crystallisation event, the drawdown price lock calculation displayed on screen here will assume a proportional strategy.",
};
